import { CATEGORY_IDENTIFIERS, SESSION_NOTE_FIELDS } from 'src/constants/dynamicFields';

// serviceCode and serviceCodeV2 share the label key `templates.appointment.serviceCode`, so offering
// both produces two identically named columns. V2 carries the numeric code for Lumary, where the
// legacy field carries the service name instead.
const SUPERSEDED_FIELD_IDS = [SESSION_NOTE_FIELDS.SERVICE_CODE];

/**
 * Appointment-category note fields, as offered to the clinic.
 *
 * Expects the presets already gated by integration — pass `sessionNoteFieldPresets` from the
 * SessionNotesTemplates mixin, not the raw `fixedSessionNoteFieldPresets`.
 *
 * @param {Object[]} presets - integration-gated note field presets
 * @return {Object[]} presets in their original order
 */
export default function getNoteAppointmentFieldPresets(presets) {
  return (presets || []).filter((preset) => (
    preset?.category === CATEGORY_IDENTIFIERS.APPOINTMENT
    && !SUPERSEDED_FIELD_IDS.includes(preset.id)
  ));
}
